export const refs = {
  logo: document.querySelector(".navigation__logo"),
  searchBox: document.querySelector(".search__box"),
  homeButton: document.querySelector(".navigation__home"),
  libraryButton: document.querySelector(".navigation__library"),
  watchedButton: document.querySelector(".button__watched"),
  queueButton: document.querySelector(".button__queue"),
  gallery: document.querySelector(".gallery"),
  galleryCards: document.querySelectorAll(".gallery__card"),
  libraryContent: document.querySelector(".content"),
  moviesContent: document.querySelector("[data-movies]"),
  carousel: document.querySelector(".carousel__container"),
  carouselLeft: document.querySelector(".carousel__left"),
  carouselRight: document.querySelector(".carousel__right"),
  modalBackground: document.querySelector(".overlay"),
  modalClose: document.querySelector(".modal__close"),
  modalWatch: document.querySelector(".modal__watch"),
  modalQueue: document.querySelector(".modal__queue"),
  modalImg: document.querySelector(".modal__poster"),
  pageCurrent: 1,
  pageMax: 1,
  moviesRemaining: [],
  moviesPerPage: 9,
};
